import { serveRightRailImprovementsWithoutExposure } from '../../utils/experiments';
import { ProductKeys } from '../product-keys';

// TODO QS-4805: We're slowly moving all filter typing to use this as a reference so we can be strongly typed!
// If you find a filterId masquerading as a `string` please consider migrating it
export type FilterId =
	| 'archived'
	| 'assignee'
	| 'reporter'
	| 'commentedByMe'
	| 'content'
	| 'contributor'
	| 'createdBy'
	| 'lastUpdated'
	| 'project'
	| 'space'
	| 'verified'
	| 'onlyTitleMatch'
	| 'universalTypeFilter'
	| 'focusAreaType'
	| 'focusAreaUnder'
	| 'owner'
	| 'label'
	| 'pageStatus'
	| 'lastUpdatedBy'
	| 'statusFilter'
	| 'compassArchived'
	| 'assetsSchema'
	| 'assetsType'
	| 'watchedByMe'
	| 'positionStatus'
	| 'positionEmploymentType'
	| 'positionJobFamily'
	| 'positionTeam'
	| 'positionFocusArea'
	| 'sort'
	| 'salesforceStage'
	| 'closeDate'
	| 'opportunityStatus'
	| 'campaignStatus'
	| 'pullRequestStatus';
// Keeping these separate for now

export const universalTypeFilterId = 'universalTypeFilter';
export const filterIdOrdering: string[] = [
	'lastUpdated',
	universalTypeFilterId,
	'contributor',
	'space',
	'createdBy',
	'lastUpdatedBy',
	'owner',
	'opportunityStatus',
	'campaignStatus',
	'closeDate',
	'focusAreaType',
	'focusAreaUnder',
	'assignee',
	'reporter',
	'project',
	'content',
	'label',
	'pageStatus',
	'verified',
	'onlyTitleMatch',
	'archived',
	'statusFilter',
	'compassArchived',
	'assetsSchema',
	'assetsType',
	'watchedByMe',
	'positionFocusArea',
	'positionStatus',
	'positionJobFamily',
	'positionTeam',
	'commentedByMe',
	'positionEmploymentType',
	'salesforceStage',
	'pullRequestStatus',
];

export const getFilterIdOrdering: () => string[] = (): string[] => {
	return filterIdOrdering.filter((_filterId) => {
		// Add feature gate checks here
		return true;
	});
};

export const SEARCH_PAGE_FILTER_CONFIG_KEY = 'search-page-hidden-filters';
export const SEARCH_PAGE_FILTER_CONFIG_KEY_V2 = 'search-page-hidden-filters-v2';

export const getSearchPageFilterConfigKey: () => string = (): string => {
	return serveRightRailImprovementsWithoutExposure()
		? SEARCH_PAGE_FILTER_CONFIG_KEY_V2
		: SEARCH_PAGE_FILTER_CONFIG_KEY;
};

export const ALL_FILTER_EXCLUDED_PRODUCTS: ('outlook-mail' | 'gmail' | 'trello')[] = [
	ProductKeys.Trello,
	ProductKeys.Gmail,
	ProductKeys.OutlookMail,
];
